import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { AjaxService, FormValidationService } from '../core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.less']
})
export class ForgotPasswordComponent implements OnInit {
  forgotform = new FormGroup({});
  forgotmodel: any = {};
  forgotoptions: FormlyFormOptions = {};
  forgotfields: FormlyFieldConfig[] = [
    {
      key: 'Email',
      type: 'input',
      wrappers: ['loginWrapper1'],
      templateOptions: {
        required: true
      },
      expressionProperties: {
        'templateOptions.label': this._translateService.stream('LblEmail'),
      }
    }
  ];
  constructor(private _translateService: TranslateService,
    private _formValidationService: FormValidationService,
    private _ajaxService: AjaxService,
    private _confirmationService: ConfirmationService,
    private router:Router) { }

  ngOnInit(): void {
  }

  forgotPassword() {
    const value = { ...this.forgotmodel };
    this._formValidationService.markFormGroupTouched(this.forgotform);
    if (this.forgotform.valid) {
      this._ajaxService.post('/auth/forgotPassword', value).subscribe((response) => {
        if (response.success) {
          this._confirmationService.confirm({
            message: this._translateService.instant('LblEmailSent'),
            rejectVisible: false,
            icon: 'pi pi-info-circle',
            acceptLabel: this._translateService.instant('LblOk'),
            accept: () => {
              this.router.navigate(['login/patient']);
              //Actual logic to perform a confirmation
            }
          });
        } else {
          this._confirmationService.confirm({
            message: response.error,
            rejectVisible: false,
            icon: 'pi pi-info-circle',
            acceptLabel: this._translateService.instant('LblOk'),
            accept: () => {
              //Actual logic to perform a confirmation
            }  
          }); 
        } 
      });   
    }
  }

}
